<template>
  <LeadButton :variant="active ? 'secondary' : 'white'" size="sm" pill class="tw:h-6">
    <slot>{{ text }}</slot>
  </LeadButton>
</template>

<script setup lang="ts">
// ToggleButton — a small pill that reads active/inactive. Delegates all
// visuals to LeadButton so it inherits DS colors, focus ring, and pill radius.
// `active` picks the variant (secondary = black-filled = "on";
// white = gray-outline = "off"). Extra props/attrs (`@click`, `data-testid`,
// `class`) fall through via inheritAttrs to LeadButton's root.
import LeadButton from '@/components/lead-design/LeadButton.vue';

defineProps<{ active: boolean; text?: string | number }>();
</script>
